import React from "react";
import "./Navbar.scss";
import toggleIcon from "../../assets/icons/toggle.svg";
import brandIcon from "../../assets/icons/brand-logo.svg";

export default class Navbar extends React.Component {
  state = {
    toggle: false,
  };

  toggleHandler = () => {
    this.setState({
      toggle: !this.state.toggle,
    });
  };

  render() {
    const { toggle } = this.state;
    return (
      <nav className="navBar">
        <div className="navBar__container">
          <div className="navBar__brand-name-container">
            <a href="#hero">
              <img src={brandIcon} alt="Logo" className="navBar__brand-logo" />
            </a>
            <a href="#hero">
              <h3 className="navBar__brand-title">JENSEN CHAN</h3>
            </a>
          </div>
          <button className="navBar__toggle-btn" onClick={this.toggleHandler}>
            <img src={toggleIcon} alt="toggle icon" width="20px" />
          </button>
        </div>
        {toggle ? (
          <div className="navBar__menu navBar__menu-on">
            <a href="#about" onClick={this.toggleHandler}>
              <li className="navBar__menu-item">About</li>
            </a>
            <a href="#project" onClick={this.toggleHandler}>
              <li className="navBar__menu-item">Project</li>
            </a>
            <a href="#contact" onClick={this.toggleHandler}>
              <li className="navBar__menu-item">Contact</li>
            </a>
          </div>
        ) : (
          <div className="navBar__menu navBar__menu-off navBar__menu-desktop">
            <a href="#about">
              <li className="navBar__menu-item navBar__menu-item-off navBar__menu-item-desktop">
                About
              </li>
            </a>
            <a href="#project">
              <li className="navBar__menu-item navBar__menu-item-off navBar__menu-item-desktop">
                Project
              </li>
            </a>
            <a href="#contact">
              <li className="navBar__menu-item navBar__menu-item-off navBar__menu-item-desktop">
                Contact
              </li>
            </a>
          </div>
        )}
      </nav>
    );
  }
}
